class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    
    // Initialize grid visibility on page load
    document.addEventListener('DOMContentLoaded', () => {
      FacetFiltersForm.toggleGridVisibility();
    });
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector('.collection');
      if (collectionElement) {
        collectionElement.classList.add('loading');
      }
    }
    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        const gridContainer = FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function' && gridContainer) {
          initializeScrollAnimationTrigger(gridContainer);
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    const gridContainer = FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function' && gridContainer) {
      initializeScrollAnimationTrigger(gridContainer);
    }
  }

  static renderProductGridContainer(html) {
    try {
      const container = document.getElementById('ProductGridContainer');
      if (!container) return null;

      const parsed = new DOMParser().parseFromString(html, 'text/html');

      // Prefer swapping the exact product grid section to avoid false empty-state
      const incomingGrid = parsed.getElementById('product-grid');
      const currentGrid = document.getElementById('product-grid');

      if (incomingGrid && currentGrid) {
        // Prefer replacing just the grid content; keep the same node and dataset
        const incomingList = incomingGrid.querySelector('.js-filter-grid');
        const currentList = currentGrid.querySelector('.js-filter-grid');
        if (incomingList && currentList) {
          currentList.innerHTML = incomingList.innerHTML;
          // Pagination is handled externally, not inside the grid
        } else {
          // If list not found, replace entire product-grid content
          currentGrid.innerHTML = incomingGrid.innerHTML;
        }
      } else {
        // Fallback: replace the whole container if specific grid not found
        const incomingContainer = parsed.getElementById('ProductGridContainer');
        if (incomingContainer) {
          container.innerHTML = incomingContainer.innerHTML;
        }
      }

      if (typeof window.reinitializeCustomCollectionFilters === 'function') {
        window.reinitializeCustomCollectionFilters(container);
      }

      // Hide filter options with zero count after product grid update
      FacetFiltersForm.hideZeroCountOptions();

      // Reinitialize price range checkboxes after AJAX reload
      FacetFiltersForm.reinitializePriceRanges();

      // Show/hide appropriate grid based on active filters
      FacetFiltersForm.toggleGridVisibility();

      // Update external pagination (outside ProductGridContainer)
      FacetFiltersForm.updateExternalPagination(html);

      // Bind AJAX pagination within the grid
      FacetFiltersForm.bindPaginationLinks();

      // Reinitialize spoilers after product grid update with a small delay to ensure DOM is ready
      setTimeout(() => {
        if (typeof window.spollers === 'function') {
          window.spollers();
        }
        // Reinitialize collection view after content update
        if (typeof window.reinitializeCollectionView === 'function') {
          window.reinitializeCollectionView();
        }
        // Recalculate featured product heights after grid update
        if (typeof window.updateFeaturedProductHeights === 'function') {
          window.updateFeaturedProductHeights();
        }
      }, 50);

      return container;
    } catch (err) {
      // Handle error silently
      return null;
    }
  }

  static toggleGridVisibility() {
    const container = document.getElementById('ProductGridContainer') || document.getElementById('ProductGridContainerPagination');
    if (!container) return;

    // Check if there are active filters
    const activeFilters = container.querySelectorAll('.facet-checkbox:checked, .field__input[value]:not([value=""])');
    const hasActiveFilters = activeFilters.length > 0;

    // Find the grids
    const blocksGrid = container.querySelector('.shop__grid--blocks');
    const collectionGrid = container.querySelector('.shop__grid--collection');


    if (blocksGrid && collectionGrid) {
      if (hasActiveFilters) {
        // Show collection grid, hide blocks grid
        blocksGrid.style.display = 'none';
        collectionGrid.style.display = '';
      } else {
        // Show blocks grid, hide collection grid
        blocksGrid.style.display = '';
        collectionGrid.style.display = 'none';
      }
    }
  }

  static updateExternalPagination(html) {
    try {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      
      // Find external pagination in the incoming HTML (outside both ProductGridContainer and ProductGridContainerPagination)
      const incomingExternalPagination = parsed.querySelector('.pagging.shop__pagging');
      
      // Find current external pagination on the page (outside both containers)
      const currentExternalPagination = document.querySelector('.pagging.shop__pagging');
      
      if (incomingExternalPagination) {
        // Remove all existing pagination elements first
        const allPaginationElements = document.querySelectorAll('.pagging.shop__pagging');
        allPaginationElements.forEach(pagination => {
          pagination.remove();
        });
        
        // Add the new pagination after the last container
        const container = document.getElementById('ProductGridContainer') || document.getElementById('ProductGridContainerPagination');
        if (container) {
          container.insertAdjacentHTML('afterend', incomingExternalPagination.outerHTML);
        }
      } else {
        // Remove all existing pagination elements if none returned
        const allPaginationElements = document.querySelectorAll('.pagging.shop__pagging');
        allPaginationElements.forEach(pagination => {
          pagination.remove();
        });
      }
    } catch (err) {
      console.error('External pagination update failed', err);
    }
  }

  static bindPaginationLinks() {
    const container = document.getElementById('ProductGridContainer') || document.getElementById('ProductGridContainerPagination');
    if (!container) return;

    // Bind pagination links both inside and outside the ProductGridContainer
    const paginateAnchors = document.querySelectorAll('.pagging__list a, .pagging__arrow[href]');
    paginateAnchors.forEach((a) => {
      a.addEventListener('click', (e) => {
        // Only intercept left click without modifier keys
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        try {
          const url = new URL(a.href, window.location.origin);
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.delete('section_id');

          url.searchParams.forEach((value, key) => {
            searchParams.delete(key);
          });

          url.searchParams.forEach((value, key) => {
            searchParams.append(key, value);
          });

          FacetFiltersForm.renderPage(searchParams.toString(), null, true);
        } catch (err) {
          // Fallback to normal navigation if URL parsing fails
          window.location.href = a.href;
        }
      }, { once: false });
    });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHTML.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    if (countElement && container) {
      const count = countElement.innerHTML;
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }
    
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        const currentBody = currentElement.querySelector('.item-filter__body');
        const incomingBody = elementToRender.querySelector('.item-filter__body');
        if (currentBody && incomingBody) {
          currentBody.innerHTML = incomingBody.innerHTML;
        } else {
          currentElement.innerHTML = elementToRender.innerHTML;
        }
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (typeof window.reinitializeCustomCollectionFilters === 'function') {
      window.reinitializeCustomCollectionFilters(document);
    }

    // Hide filter options with zero count
    FacetFiltersForm.hideZeroCountOptions();

    // Reinitialize spoilers after DOM updates with a small delay to ensure DOM is ready
    setTimeout(() => {
      if (typeof window.spollers === 'function') {
        window.spollers();
      }
      // Reinitialize collection view after content update
      if (typeof window.reinitializeCollectionView === 'function') {
        window.reinitializeCollectionView();
      }
      // Update active filters after content update
      if (typeof window.updateActiveFilters === 'function') {
        window.updateActiveFilters();
      }
    }, 50);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && menuDrawer.bindEvents) {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    const productGridEmpty = document.getElementById('product-grid-empty');
    const gridElement = productGrid || productGridEmpty;
    
    return [
      {
        section: gridElement ? gridElement.dataset.id : '',
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    
    // Preserve search query on search pages
    const currentUrl = new URL(window.location);
    const searchQuery = currentUrl.searchParams.get('q');
    if (searchQuery && window.location.pathname.includes('/search')) {
      searchParams.set('q', searchQuery);
    }

    searchParams.delete('page');

    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const form = event.target.closest('form');
      if (form) {
        const searchParams = this.createSearchParams(form);
        this.onSubmitForm(searchParams, event);
      }
    } else {
      const forms = [];
      const targetForm = event.target.closest('form');
      const isMobile = targetForm && targetForm.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const urlParams = new URLSearchParams(url);
    
    // Preserve search query on search pages when removing filters
    const currentUrl = new URL(window.location);
    const searchQuery = currentUrl.searchParams.get('q');
    if (searchQuery && window.location.pathname.includes('/search')) {
      urlParams.set('q', searchQuery);
    }
    urlParams.delete('page');
    
    FacetFiltersForm.renderPage(urlParams.toString());
  }

  static hideZeroCountOptions() {
    // Hide filter checkboxes with zero count (but keep active ones visible)
    const filterCheckboxes = document.querySelectorAll('.item-filter__checkbox');
    
    filterCheckboxes.forEach((checkboxContainer) => {
      const checkbox = checkboxContainer.querySelector('input[type="checkbox"], input.facet-checkbox');
      const label = checkboxContainer.querySelector('.checkbox__text');
      
      if (checkbox && label) {
        // Extract count from label text (assuming format: "Label (count)")
        const labelText = label.textContent.trim();
        const countMatch = labelText.match(/\((\d+)\)$/);
        
        if (countMatch) {
          const count = parseInt(countMatch[1]);
          const isActive = checkbox.checked;
          
          // Hide if count is 0 and not currently active/selected
          if (count === 0 && !isActive) {
            checkboxContainer.style.display = 'none';
            checkboxContainer.setAttribute('data-hidden-zero-count', 'true');
          } else {
            checkboxContainer.style.display = '';
            checkboxContainer.removeAttribute('data-hidden-zero-count');
          }
        }
      }
    });

    // Also hide mobile filter options with zero count
    const mobileFilterCheckboxes = document.querySelectorAll('.mobile-facets__checkbox');
    
    mobileFilterCheckboxes.forEach((checkboxContainer) => {
      const checkbox = checkboxContainer.querySelector('input[type="checkbox"]');
      const label = checkboxContainer.querySelector('.mobile-facets__label');
      
      if (checkbox && label) {
        const labelText = label.textContent.trim();
        const countMatch = labelText.match(/\((\d+)\)$/);
        
        if (countMatch) {
          const count = parseInt(countMatch[1]);
          const isActive = checkbox.checked;
          
          if (count === 0 && !isActive) {
            checkboxContainer.style.display = 'none';
            checkboxContainer.setAttribute('data-hidden-zero-count', 'true');
          } else {
            checkboxContainer.style.display = '';
            checkboxContainer.removeAttribute('data-hidden-zero-count');
          }
        }
      }
    });

    // Handle filter sections that might be completely empty
    FacetFiltersForm.handleEmptyFilterSections();
  }

  static handleEmptyFilterSections() {
    const filterSections = document.querySelectorAll('.item-filter');
    
    filterSections.forEach((section) => {
      const checkboxes = section.querySelectorAll('.item-filter__checkbox');
      const visibleCheckboxes = Array.from(checkboxes).filter(checkbox => 
        checkbox.style.display !== 'none' && !checkbox.hasAttribute('data-hidden-zero-count')
      );
      
      const filterBody = section.querySelector('.item-filter__body');
      if (filterBody) {
        // Remove any existing "no options" message
        const existingMessage = filterBody.querySelector('.no-options-message');
        if (existingMessage) {
          existingMessage.remove();
        }
        
        // If no visible checkboxes, show a message or hide the section
        if (visibleCheckboxes.length === 0) {
          const message = document.createElement('div');
          message.className = 'no-options-message';
          message.style.cssText = 'color: rgba(var(--color-foreground), 0.6); font-style: italic; font-size: 0.875rem; padding: 0.5rem 0;';
          message.textContent = 'No options available';
          filterBody.appendChild(message);
          
          // Optionally disable the filter title
          const filterTitle = section.querySelector('.item-filter__title');
          if (filterTitle) {
            filterTitle.style.opacity = '0.6';
            filterTitle.style.pointerEvents = 'none';
          }
        } else {
          // Re-enable the filter title if there are visible options
          const filterTitle = section.querySelector('.item-filter__title');
          if (filterTitle) {
            filterTitle.style.opacity = '';
            filterTitle.style.pointerEvents = '';
          }
        }
      }
    });
  }

  static reinitializePriceRanges() {
    
    // Get current URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const currentMinPrice = urlParams.get('filter.v.price.gte');
    const currentMaxPrice = urlParams.get('filter.v.price.lte');
    
    
    // Find all price range checkboxes
    const priceRangeCheckboxes = document.querySelectorAll('price-range input[type="checkbox"]');
    
    priceRangeCheckboxes.forEach((checkbox) => {
      const minPrice = checkbox.value;
      const maxPrice = checkbox.getAttribute('data-max-price');
      
      
      // Check if this checkbox should be active
      let shouldBeChecked = false;
      
      if (!maxPrice || maxPrice === '' || maxPrice === '+') {
        // For ranges like €300+ (no max price)
        if (currentMinPrice === minPrice && !currentMaxPrice) {
          shouldBeChecked = true;
        }
      } else {
        // For ranges with both min and max
        if (currentMinPrice === minPrice && currentMaxPrice === maxPrice) {
          shouldBeChecked = true;
        }
      }
      
      
      if (shouldBeChecked !== checkbox.checked) {
        checkbox.checked = shouldBeChecked;
        
        // Enable/disable the paired hidden input
        const pairedInput = document.querySelector(`input[data-paired-with="${checkbox.id}"]`);
        if (pairedInput) {
          pairedInput.disabled = !shouldBeChecked;
        }
      }
    });
    
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
window.FacetFiltersForm = FacetFiltersForm;
FacetFiltersForm.setListeners();

// Hide zero count options and reinitialize price ranges on initial page load
document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.reinitializeCustomCollectionFilters === 'function') {
    window.reinitializeCustomCollectionFilters(document);
  }
  FacetFiltersForm.hideZeroCountOptions();
  FacetFiltersForm.reinitializePriceRanges();
});

// Listen for custom filter removal events
window.addEventListener('filterRemoved', (event) => {
  const searchParams = event.detail.searchParams;
  if (searchParams) {
    const urlParams = new URLSearchParams(searchParams);
    urlParams.delete('page');
    FacetFiltersForm.renderPage(urlParams.toString(), null, true);
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input[type="checkbox"]').forEach((element) => {
      element.addEventListener('change', this.onPriceRangeChange.bind(this));
    });
  }

  onPriceRangeChange(event) {
    const checkbox = event.currentTarget;
    const isChecked = checkbox.checked;
    const minPrice = checkbox.value;
    const maxPrice = checkbox.getAttribute('data-max-price');
    
    // Uncheck all other price range checkboxes and disable their hidden inputs
    this.querySelectorAll('input[type="checkbox"]').forEach((otherCheckbox) => {
      if (otherCheckbox !== checkbox) {
        otherCheckbox.checked = false;
        // Disable the paired hidden max price input
        const pairedInput = this.querySelector(`input[data-paired-with="${otherCheckbox.id}"]`);
        if (pairedInput) {
          pairedInput.disabled = true;
        }
      }
    });
    
    // Enable/disable the hidden max price input for this checkbox
    const pairedInput = this.querySelector(`input[data-paired-with="${checkbox.id}"]`);
    if (pairedInput) {
      pairedInput.disabled = !isChecked;
    }
    
    // If this checkbox is being unchecked, clear the price filter
    if (!isChecked) {
      // Remove price filter parameters from URL
      const url = new URL(window.location);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      window.history.replaceState({}, '', url);
    } else {
      // Add price filter parameters to URL
      const url = new URL(window.location);
      url.searchParams.set('filter.v.price.gte', minPrice);
      if (maxPrice && maxPrice !== '+' && maxPrice !== '') {
        url.searchParams.set('filter.v.price.lte', maxPrice);
      }
      window.history.replaceState({}, '', url);
    }
    
    // Trigger form submission
    const form = this.closest('form');
    if (form) {
      const event = new Event('input', { bubbles: true });
      form.dispatchEvent(event);
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
